import React from 'react';
import {Redirect, withRouter} from 'react-router-dom';

/**
 * Copyright (c) Fing Ltd. All rights reserved.
 */
class AccountRootPage extends React.Component {

    // --------------------------------------------------------------------------------
    // MAIN RENDER FUNCTION
    // --------------------------------------------------------------------------------

    render() {
        return <Redirect to="/account/dashboard"/>;
    }

}

export default withRouter(AccountRootPage)